import { Box, Typography } from '@mui/material';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider as SEOSegmentationProvider } from '@/__generated__/seoSegmentationListingPage';
import { RATE_DURATION_ABBREVIATIONS } from '@/constants';

export interface SMBRateProps {
  providerRate: NonNullable<SEOSegmentationProvider['providerRate']>;
}

export const SMBRate = ({ providerRate }: SMBRateProps) => {
  const { isSmallViewport } = useResponsive();

  return isSmallViewport ? (
    <Typography variant="h5" component="div">
      starting at ${providerRate.rate.amount}/
      {RATE_DURATION_ABBREVIATIONS[providerRate.rateDuration]}
    </Typography>
  ) : (
    <Box component="dl" display="flex" flexDirection="column" alignItems="flex-end" m={0}>
      <Typography variant="body3" component="dt">
        starting at
      </Typography>
      <Typography variant="h2" component="dd">
        ${providerRate.rate.amount}/{RATE_DURATION_ABBREVIATIONS[providerRate.rateDuration]}
      </Typography>
    </Box>
  );
};
